import { Injectable } from '@angular/core';
import { AppCacheService, CacheEntry, ClientOrigin } from '../../../cache/app-cache.service';

const LAST_VIEWED_PIPELINE_ORIGIN_KEY = ClientOrigin.PIPELINE_PAGE_VIEW;

export enum PipelineBoardViews {
  DEFAULT_TABLE = 'default-table',
  DEFAULT_BOARD = 'default-board',
}

@Injectable()
export class PipelinePageCacheService {
  constructor(private readonly appCache: AppCacheService) {}

  get lastViewedPipelinePageView(): PipelineBoardViews {
    const cacheEntry = this.appCache.get(LAST_VIEWED_PIPELINE_ORIGIN_KEY);
    return cacheEntry.isCacheHit
      ? this.appCache.get(LAST_VIEWED_PIPELINE_ORIGIN_KEY).value
      : PipelineBoardViews.DEFAULT_BOARD;
  }

  setLastViewedPipelinePageView(view: PipelineBoardViews): void {
    const entry = <CacheEntry>{
      origin: LAST_VIEWED_PIPELINE_ORIGIN_KEY,
      value: JSON.stringify(view),
    };
    this.appCache.add(entry);
  }
}
